import React from 'react';
import { Typography, Chip, Button, useMediaQuery } from '@material-ui/core';
import { Add as AddIcon, ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon, } from '@material-ui/icons';
import clsx from 'clsx';
export var PopularKeywords = function (_a) {
    var keywords = _a.keywords, title = _a.title, _b = _a.breakPoint, breakPoint = _b === void 0 ? 480 : _b, _c = _a.heightThreshold, heightThreshold = _c === void 0 ? 40 : _c, onSelect = _a.onSelect;
    var mobile = useMediaQuery("(max-width:".concat(breakPoint, "px)"));
    var _d = React.useState(false), open = _d[0], setOpen = _d[1];
    var _e = React.useState(0), height = _e[0], setHeight = _e[1];
    var measuredRef = React.useCallback(function (node) {
        setHeight((node === null || node === void 0 ? void 0 : node.clientHeight) || 0);
    }, []);
    React.useEffect(function () {
        setOpen(!mobile);
    }, [mobile]);
    return (React.createElement("div", { className: "faq-filter-search-keyword" },
        title && (React.createElement(Typography, { variant: "h2", className: "faq-filter-search-keyword__title" }, title)),
        React.createElement("div", null,
            React.createElement("div", { ref: measuredRef, className: clsx('faq-filter-search-keyword__wrapper', {
                    less: !open,
                    more: open,
                    noLoad: keywords.length === 0,
                }) }, keywords.map(function (k) { return (React.createElement(Chip, { key: k, className: clsx('faq-filter-search-keyword-chip', 'faq-filter-search-keyword__chip'), icon: React.createElement(AddIcon, null), label: k, onClick: function () { return onSelect(k); } })); })),
            React.createElement(Button, { className: clsx('faq-filter-search-keyword__button', 'faq-filter-search-keyword-expand-button', {
                    'faq-filter-search-keyword__button--mobile': mobile && height > heightThreshold,
                }), endIcon: open ? React.createElement(ExpandLessIcon, null) : React.createElement(ExpandMoreIcon, null), onClick: function () { return setOpen(function (prev) { return !prev; }); }, size: "small", fullWidth: true }, open ? '閉じる' : 'もっと見る'))));
};
//# sourceMappingURL=PopularKeywords.js.map